(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["block_bundle_price"] && !Shopify.designMode) return;
  try {
    if (!window.bundleInit) {
window.bundleInit = true;
document.addEventListener('click', async (e) => {
const btn = e.target.closest('.bundle-add-btn');
if (!btn) return;
const bundle = btn.closest('[data-bundle]');
const dataEl = bundle.querySelector('.bundle-data');
if (!dataEl) return;
const items = JSON.parse(dataEl.dataset.items);
// Safety check
const hasSoldOut = items.some(item => !item.available);
if (hasSoldOut) {
    alert('Some items are sold out');
    return;
}
btn.classList.add('loading');
try {
    await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
        items: items.map(item => ({
        id: item.id,
        quantity: 1
        }))
    })
    });
    import('@theme/events').then(({ CartUpdateEvent }) => {
    const cartDrawer = document.querySelector('cart-drawer-component');    
    fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
    const event = new CartUpdateEvent(cart, 'manual-trigger', {
        itemCount: cart.item_count,
        source: 'fad-refresh',
        sections: {}
    });
    document.dispatchEvent(event);
    if (cartDrawer?.hasAttribute('auto-open')) {
        cartDrawer.open();
    }
    });
});
} catch (err) {
    console.error('Bundle error:', err);
}
btn.classList.remove('loading');
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["block_collection_products"] && !Shopify.designMode) return;
  try {
    function initSlider(id) {
    const slider = document.getElementById('slider-' + id);
    if (!slider) return;
    const track = document.getElementById('track-' + id);
    const prev = slider.querySelector('.collection-slider-prev');
    const next = slider.querySelector('.collection-slider-next');
    const dotsWrap = document.getElementById('dots-' + id);
    const autoplay = slider.dataset.autoplay === 'true';
    const speed = parseInt(slider.dataset.speed) || 3000;
    let index = 0;
    const slides = track.children;
    function getPerRow() {
      const style = getComputedStyle(slider);

      if (window.innerWidth >= 1366) {
        return parseInt(style.getPropertyValue('--per-row-desktop')) || 1;
      }
      if (window.innerWidth >= 768) {
        return parseInt(style.getPropertyValue('--per-row-tablet')) || 1;
      }
      return parseInt(style.getPropertyValue('--per-row-mobile')) || 1;
    }
    function go(i) {
      const perRow = getPerRow();
      const pages = Math.ceil(slides.length / perRow);
      const maxIndex = (pages - 1) * perRow;
      if (i < 0) i = 0;
      if (i > maxIndex) i = maxIndex;
      index = i;
      const slide = slides[index];
      if (!slide) return;
      track.scrollTo({
        left: slide.offsetLeft,
        behavior: 'smooth',
      });
      updateDots();
    }

    if (prev) prev.onclick = () => go(index - getPerRow());
    if (next) next.onclick = () => go(index + getPerRow());
    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      const perRow = getPerRow();
      const pages = Math.ceil(slides.length / perRow);
      for (let i = 0; i < pages; i++) {
        let b = document.createElement('button');
        b.onclick = () => go(i * perRow);
        dotsWrap.appendChild(b);
      }
    }

    function updateDots() {
      if (!dotsWrap) return;
      const perRow = getPerRow();
      const page = Math.round(index / perRow);
      dotsWrap.querySelectorAll('button').forEach((d, i) => {
        d.classList.toggle('active', i === page);
      });
    }

    if (autoplay) {
      setInterval(() => {
        go(index + getPerRow());
      }, speed);
    }
    let isDown = false;
    let startX;
    let scrollLeft;
    track.addEventListener('pointerdown', (e) => {
      isDown = true;
      startX = e.pageX;
      scrollLeft = track.scrollLeft;
    });
    track.addEventListener('pointerup', () => (isDown = false));
    track.addEventListener('pointerleave', () => (isDown = false));
    track.addEventListener('pointermove', (e) => {
      if (!isDown) return;
      const walk = e.pageX - startX;
      track.scrollLeft = scrollLeft - walk;
    });
    buildDots();
    updateDots();
    window.addEventListener('resize', () => {
      buildDots();
      updateDots();
    });
  }
  document.querySelectorAll('.slider_block, .collection_block_slider').forEach((el) => {
    initSlider(el.dataset.id);
  });

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.slider_block, .collection_block_slider').forEach((el) => {
      initSlider(el.dataset.id);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["block_marquee"] && !Shopify.designMode) return;
  try {
    function initMarquee(block) {
  if (block.marqueeInit) return;
  block.marqueeInit = true;

  const track = block.querySelector(".marquee-track");
  const loop = block.querySelector(".marquee-loop");

  let speedDesktop = parseFloat(block.dataset.speed) || 1;
  let speedMobile = parseFloat(block.dataset.speedM) || 1;

  let reverse = block.dataset.reverse === "true";
  let pauseHover = block.dataset.hover === "true";
  let drag = block.dataset.drag === "true";
  let dup = block.dataset.dup === "true";

  let pos = 0;
  let lastTime = 0;
  let isPaused = false;
  let isDown = false;
  let startX = 0;

  let loopSize = 0;
  let speed = 0;



  /* ---------------- SPEED ---------------- */

  function getSpeed() {
    speed =
      window.innerWidth < 768
        ? speedMobile
        : speedDesktop;
  }



  /* ---------------- DUPLICATE ---------------- */

    function buildLoop() {
      track.innerHTML = "";

      const base = loop.cloneNode(true);
      track.appendChild(base);

      /* measure AFTER render */
      const baseWidth = base.getBoundingClientRect().width;
      const containerWidth = block.getBoundingClientRect().width;

      /* fallback safety */
      if (!baseWidth || !containerWidth) return;

      /* how many copies needed (MAX 2–3 only) */
      const required = Math.ceil((containerWidth * 2) / baseWidth);

      for (let i = 0; i < required; i++) {
        const clone = loop.cloneNode(true);
        track.appendChild(clone);
      }

      loopSize = baseWidth;
    }


  /* ---------------- ANIMATION ---------------- */

    function frame(time) {

      if (!lastTime) lastTime = time;

      const delta = time - lastTime;

      lastTime = time;

      if (!isPaused && !isDown) {

        const move = (speed * delta) / 50;

        pos += reverse ? move : -move;

        /* ✅ smooth infinite using modulo */

        if (loopSize > 0) {
          pos = pos % loopSize;
        }

        track.style.transform =
          `translate3d(${pos}px,0,0)`;
      }

      requestAnimationFrame(frame);
    }


  /* ---------------- HOVER ---------------- */

  if (pauseHover) {
    block.addEventListener("mouseenter", () => {
      isPaused = true;
    });

    block.addEventListener("mouseleave", () => {
      isPaused = false;
    });
  }

  /* ---------------- INIT ---------------- */

  function init() {
    getSpeed();
    buildLoop();
    lastTime = 0;
  }

  init();

  requestAnimationFrame(frame);
}



/* ---------- INIT ---------- */

  document.querySelectorAll('[id^="marquee-"]').forEach((container) => {
    initMarquee(container);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["block_product"] && !Shopify.designMode) return;
  try {
    function initProductScript(sectionId) {
  //console.log(sectionId)
  const section = document.getElementById(sectionId);
  if (!section) return;

  /* -------------------------
     HELPERS
  -------------------------- */
  const $ = (sel, parent = section) => parent?.querySelector(sel);
  const $$ = (sel, parent = section) => parent ? [...parent.querySelectorAll(sel)] : [];
  const shopCurrency = section.dataset.currency;
  const shopLocale = section.dataset.locale;
    const formatMoney = (cents) => {
    const rate = Shopify?.currency?.rate || 1;
    const converted = (cents / 100);
    return new Intl.NumberFormat(Shopify.locale, {
      style: 'currency',
      currency: Shopify.currency.active,
    }).format(converted);
  };

  /* -------------------------
     GALLERY
  -------------------------- */
  function initGallery() {
  const gallery = $('.custom-product-gallery');
  if (!gallery) return;

  const isCarousel = gallery.classList.contains('enabled_media_carousel'); // ✅ detect mode

  const mainItems = $$('.gallery-media-item', gallery);
  const thumbs = $$('.gallery-thumb', gallery);
  const track = $('.gallery-thumbs-track', gallery);
  const wrapper = $('.gallery-thumbs-wrapper', gallery);

  const thumbPrev = $('.thumb-prev', gallery);
  const thumbNext = $('.thumb-next', gallery);

  const mainPrev = $('.main-prev', gallery);
  const mainNext = $('.main-next', gallery);

  if (!mainItems.length) return;

  let currentIndex = 0;
  let currentTranslate = 0;

  /* ---------------- SLIDE ---------------- */
  function showSlide(index) {
    // ❌ Disable slider behavior in carousel mode
    if (isCarousel) return;

    currentIndex = (index + mainItems.length) % mainItems.length;

    mainItems.forEach((el, i) => {
      el.classList.toggle('is-active', i === currentIndex);

      const video = el.querySelector("video");
      if (video) video.pause();
    });

    thumbs.forEach((thumb, i) => {
      thumb.classList.toggle('is-active', i === currentIndex);
    });

    scrollThumbIntoView();
  }

  /* ---------------- THUMB CLICK ---------------- */
  if (!isCarousel) {
    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => showSlide(i));
    });
  }

  /* ---------------- THUMB SCROLL BUTTONS ---------------- */
  thumbPrev?.addEventListener('click', () => {
    currentTranslate += 100;
    if (currentTranslate > 0) currentTranslate = 0;
    track.style.transform = `translateX(${currentTranslate}px)`;
  });

  thumbNext?.addEventListener('click', () => {
    const maxTranslate =
      track.parentElement.offsetWidth - track.scrollWidth;

    currentTranslate -= 100;

    if (currentTranslate < maxTranslate)
      currentTranslate = maxTranslate;

    track.style.transform = `translateX(${currentTranslate}px)`;
  });

  /* ---------------- MAIN SLIDER BUTTONS ---------------- */
  if (!isCarousel) {
    mainPrev?.addEventListener('click', () => {
      showSlide(currentIndex - 1);
    });

    mainNext?.addEventListener('click', () => {
      showSlide(currentIndex + 1);
    });
  }

  /* ---------------- OVERFLOW ---------------- */
  function checkOverflow() {
    if (!track) return;

    const container = track.parentElement;

    const isOverflowing =
      Math.ceil(track.scrollWidth) >
      Math.ceil(container.clientWidth);

    wrapper?.classList.toggle("is-overflowing", isOverflowing);

    if (!isOverflowing) {
      currentTranslate = 0;
      track.style.transform = "translateX(0px)";
    }
  }

  /* ---------------- AUTO SCROLL ACTIVE THUMB ---------------- */
  function scrollThumbIntoView() {
    if (!track || !thumbs[currentIndex]) return;

    const container = track.parentElement;
    const activeThumb = thumbs[currentIndex];

    const thumbRect = activeThumb.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();

    if (thumbRect.left < containerRect.left) {
      currentTranslate += (containerRect.left - thumbRect.left);
    } else if (thumbRect.right > containerRect.right) {
      currentTranslate -= (thumbRect.right - containerRect.right);
    }

    track.style.transform = `translateX(${currentTranslate}px)`;
  }

  /* ---------------- CAROUSEL MODE (OPTIONAL ENHANCEMENT) ---------------- */
  if (isCarousel) {
    // 👉 optional: click thumb → scroll to image instead of switching
    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => {
        mainItems[i]?.scrollIntoView({
          behavior: 'smooth',
          inline: 'start',
          block: 'nearest'
        });
      });
    });
  }

  /* ---------------- INIT ---------------- */
  checkOverflow();

  // ❌ only activate first slide in slider mode
  if (!isCarousel) {
    showSlide(0);
  }

  window.addEventListener("resize", checkOverflow);

  return { showSlide };
  }
  /* -------------------------
     ZOOM
  -------------------------- */
  function initZoom() {
    const zoomElement = section.querySelector('.zoom-enabled');
    if (!zoomElement) return;

    $$('.zoom-container').forEach(container => {
      const img = $('.zoom-image', container);
      if (!img) return;

      if (window.matchMedia("(hover: hover)").matches) {
        container.addEventListener('mousemove', (e) => {
          const rect = container.getBoundingClientRect();
          const x = ((e.clientX - rect.left) / rect.width) * 100;
          const y = ((e.clientY - rect.top) / rect.height) * 100;
          img.style.transformOrigin = `${x}% ${y}%`;
          img.style.transform = "scale(2)";
        });

        container.addEventListener('mouseleave', () => {
          img.style.transform = "scale(1)";
        });
      }
    });
  }

  /* -------------------------
     VARIANTS
  -------------------------- */
  function initVariants(galleryAPI) {
    let subscriptionPrice = null;
    let subscriptionCompare = null;
    const form = $("form[id^='product-form-']");
    if (!form) return;

    const variants = section.dataset.variants
      ? JSON.parse(section.dataset.variants)
      : [];

    const hiddenInput = $("input[name='id']", form);
    const optionGroups = $$('.product-option');
    const addToCartBtn = $('.add-to-cart', form);
    const priceWrapper = $('.product-price');

    let selectedOptions = [];
    let currentVariant = null;

    const initialVariant =
      variants.find(v => v.id == hiddenInput?.value) ||
      variants.find(v => v.available) ||
      variants[0];

    selectedOptions = [
      initialVariant?.option1 || null,
      initialVariant?.option2 || null,
      initialVariant?.option3 || null,
    ];

    function updateUI() {
      optionGroups.forEach((group, index) => {
        $$('.option-value', group).forEach(btn => {

          const test = [...selectedOptions];
          test[index] = btn.dataset.value;

          const matchedVariant = variants.find(v =>
            (!v.option1 || v.option1 === test[0]) &&
            (!v.option2 || v.option2 === test[1]) &&
            (!v.option3 || v.option3 === test[2])
          );
          // ACTIVE / AVAILABLE STATES
          btn.classList.toggle('is-active', btn.dataset.value === selectedOptions[index]);
          btn.classList.toggle('is-unavailable', !matchedVariant);
          btn.classList.toggle('is-soldout', matchedVariant && !matchedVariant.available);

          // -------------------------
          // 🔥 UPDATE PRICE PER OPTION
          // -------------------------
          const priceEl = btn.querySelector('.v_price');
          const compareEl = btn.querySelector('.v_compare_price');
          const savingEl = btn.querySelector('.saving');

          if (matchedVariant && priceEl) {
            priceEl.childNodes[0].nodeValue = formatMoney(matchedVariant.price) + ' ';

            if (compareEl) {
              if (matchedVariant.compare_at_price > matchedVariant.price) {
                compareEl.textContent = formatMoney(matchedVariant.compare_at_price);
                compareEl.style.display = 'inline';
              } else {
                compareEl.style.display = 'none';
              }
            }

            if (savingEl) {
              if (matchedVariant.compare_at_price > matchedVariant.price) {
                const percent = Math.round(
                  ((matchedVariant.compare_at_price - matchedVariant.price) * 100) /
                  matchedVariant.compare_at_price
                );
                savingEl.textContent = percent + '% OFF';
                savingEl.style.display = 'block';
              } else {
                savingEl.style.display = 'none';
              }
            }
          }
        });
      });
      function updateSelectedOptionsUI() {
        optionGroups.forEach((group, index) => {
          const selectedDiv = group.querySelector('.selected_optons');
          if (selectedDiv && selectedOptions[index]) {
            selectedDiv.textContent = selectedOptions[index];
          }
        });
      }
    }

    function updatePrice() {
      if (!priceWrapper || !currentVariant) return;

      const regular = $('.regular_price', priceWrapper);
      const compare = $('.sale_price', priceWrapper);
      const save = $('.save', priceWrapper);
     
      // ✅ PRIORITY: subscription > variant
      const finalPrice = subscriptionPrice || currentVariant.price;
      const finalCompare = subscriptionCompare || currentVariant.compare_at_price;
      
      if (regular) {
        regular.textContent = formatMoney(finalPrice);
      }

      if (compare && save) {
        if (finalCompare > finalPrice) {
          compare.textContent = formatMoney(finalCompare);
          compare.style.display = 'inline';

          const percent = Math.round(
            ((finalCompare - finalPrice) * 100) / finalCompare
          );

          save.textContent = percent + '% OFF';
          save.style.display = 'inline';
        } else {
          compare.style.display = 'none';
          save.style.display = 'none';
        }
      }
    }

    function updateButton() {
      if (!addToCartBtn || !currentVariant) return;
      const finalPrice = subscriptionPrice || currentVariant.price;
      const showBtnPrice = addToCartBtn.hasAttribute('data-btn-price');
      const defaultText = addToCartBtn.dataset.btnText || 'Add to Cart';
      const soldOutText = addToCartBtn.dataset.btnSoldout || 'Sold Out';
      addToCartBtn.disabled = !currentVariant.available;
      if (!currentVariant.available) {
        addToCartBtn.innerHTML = `<span class="btn_text">${soldOutText}</span>`;
        return;
      }
      if (showBtnPrice) {
        addToCartBtn.innerHTML = `
          <span class="btn_text">${defaultText}</span>
          <span class="btn_separator">—</span>
          <span class="btn_price">${formatMoney(finalPrice)}</span>
        `;
      } else {
        addToCartBtn.innerHTML = `<span class="btn_text">${defaultText}</span>`;
      }
    }
    function initAjaxAddToCart() {
        const form = $("form[id^='product-form-']");
        if (!form) return;
        form.addEventListener('submit', async (e) => {
          e.preventDefault();
          const formData = new FormData(form);
          try {
            await fetch('/cart/add.js', {
              method: 'POST',
              body: formData
            });
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
          document.querySelector('cart-drawer')?.open?.();
          document.querySelector('cart-drawer')?.classList.add('active');
          import('@theme/events').then(({ CartUpdateEvent }) => {
            const cartDrawer = document.querySelector('cart-drawer-component');    
            fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
              const event = new CartUpdateEvent(cart, 'manual-trigger', {
                itemCount: cart.item_count,
                source: 'fad-refresh',
                sections: {}
              });
              document.dispatchEvent(event);
              if (cartDrawer?.hasAttribute('auto-open')) {
                cartDrawer.open();
              }
            });
          });
          } catch (err) {
            console.error(err);
          }
        });
      }

    function updateVariant() {
      subscriptionPrice = null;
      subscriptionCompare = null;
      currentVariant = variants.find(v =>
        (!v.option1 || v.option1 === selectedOptions[0]) &&
        (!v.option2 || v.option2 === selectedOptions[1]) &&
        (!v.option3 || v.option3 === selectedOptions[2])
      );

      if (!currentVariant) return;

      if (hiddenInput) hiddenInput.value = currentVariant.id;

      if (galleryAPI && currentVariant.featured_media) {
          const mediaId = currentVariant?.featured_media?.id;
          if (!mediaId) return;

          const slides = section.querySelectorAll('.gallery-media-item');

          const index = [...slides].findIndex(
          el => el.dataset.mediaId == mediaId
          );

          if (index !== -1) {
          galleryAPI.showSlide(index);
          }
      }

      updatePrice();
      updateButton();

      section.dispatchEvent(
        new CustomEvent('variant:change', { detail: { variant: currentVariant } })
      );
    }
    function updateSelectedOptionsUI() {
      optionGroups.forEach((group, index) => {
        const selectedDiv = group.querySelector('.selected_optons');
        if (selectedDiv && selectedOptions[index]) {
          selectedDiv.textContent = selectedOptions[index];
        }
      });
    }
    function initStickyVariantSync(section) {

      const sticky = section.querySelector('.sticky-atc');
      //console.log(sticky)
      if (!sticky) return;

      const priceEl = sticky.querySelector('.sticky-price');
      const compareEl = sticky.querySelector('.sticky-compare');
      const saveEl = sticky.querySelector('.sticky-save');
      const variantEl = sticky.querySelector('.sticky-variant');
      const btn = sticky.querySelector('.sticky-btn');

      let currentVariantData = null;

      /* -------------------------
        VARIANT CHANGE
      -------------------------- */
      section.addEventListener('variant:change', (e) => {
        const variant = e.detail.variant;
        if (!variant) return;
        currentVariantData = variant;
        updateStickyUI(section);
      });
      /* -------------------------
        SEAL SUBSCRIPTION CHANGE
      -------------------------- */
      section.addEventListener('sealsubs:price_update', (e) => {

        if (!e.detail) return;

        const { price, compareAtPrice } = e.detail;

        if (!price) return;

        subscriptionPrice = price;
        subscriptionCompare = compareAtPrice || null;

        updateStickyUI(section);
      });

      /* -------------------------
        MAIN UPDATE FUNCTION
      -------------------------- */
      function updateStickyUI(section) {
      const sticky = section.querySelector('.sticky-atc');
      //console.log(section)
      if (!sticky) return;

        if (!currentVariantData) return;

        const variant = currentVariantData;

        // TITLE
        if (variantEl) {
          variantEl.textContent = [
            variant.option1,
            variant.option2,
            variant.option3
          ].filter(Boolean).join(' / ');
        }

        // PRICE (🔥 FIXED)
        if (priceEl) {
          const finalPrice = subscriptionPrice || variant.price;
          priceEl.textContent = formatMoney(finalPrice);
        }

        // COMPARE + SAVE (🔥 FIXED)
        if (compareEl && saveEl) {

          const finalCompare = subscriptionCompare || variant.compare_at_price;
          const finalPrice = subscriptionPrice || variant.price;

          if (finalCompare > finalPrice) {

            compareEl.textContent = formatMoney(finalCompare);
            compareEl.style.display = 'inline';

            const percent = Math.round(
              ((finalCompare - finalPrice) * 100) / finalCompare
            );

            saveEl.textContent = percent + '% OFF';
            saveEl.style.display = 'inline';

          } else {
            compareEl.style.display = 'none';
            saveEl.style.display = 'none';
          }
        }

        // BUTTON
        if (btn) {
          btn.disabled = !variant.available;
          const defaultText = btn.dataset.btnText || 'Add to Cart';
          const soldOutText = btn.dataset.btnSoldout || 'Sold Out';
          btn.textContent = variant.available ? defaultText : soldOutText;
        }
      }
    }
    optionGroups.forEach((group, index) => {
      $$('.option-value', group).forEach(btn => {
        btn.addEventListener('click', () => {
        if (btn.classList.contains('is-unavailable')) return;
        selectedOptions[index] = btn.dataset.value;
        const optionWrapper = btn.closest('.product-option');
        const selectedDiv = optionWrapper.querySelector('.selected_optons');
        if (selectedDiv) {
          selectedDiv.textContent = btn.dataset.value;
        }
        updateUI();
        updateVariant();
        updateSelectedOptionsUI()
      });
      });
    });
    section.addEventListener('sealsubs:price_update', (e) => {
      if (!e.detail) return;
      const { price, compareAtPrice } = e.detail;
      if (!price) return;
      subscriptionPrice = price;
      subscriptionCompare = compareAtPrice || null;
      updatePrice();       // 🔥 force UI update
      updateButton();      // 🔥 sync button
    });
    initStickyVariantSync(section);
    initAjaxAddToCart();
    updateUI();
    updateVariant();
    updateSelectedOptionsUI()
  }

  /* -------------------------
     QUANTITY
  -------------------------- */
  function initQuantity() {
    const wrapper = $('[data-quantity-wrapper]');
    if (!wrapper) return;

    const input = $('.qty-input', wrapper);
    const plus = $('.qty-plus', wrapper);
    const minus = $('.qty-minus', wrapper);

    if (!input) return;

    plus?.addEventListener('click', () => {
      input.value = parseInt(input.value || 1) + 1;
    });

    minus?.addEventListener('click', () => {
      if (input.value > 1) input.value--;
    });
  }

  /* -------------------------
     STICKY
  -------------------------- */
  function initSticky() {
  const sticky = $('.sticky-atc');
  const btn = $('.add-to-cart'); // main button

  if (!sticky || !btn) return;

  const stickyBtn = sticky.querySelector('.sticky-btn');
  const form = $("form[id^='product-form-']");

  if (stickyBtn && form) {
    stickyBtn.addEventListener('click', () => {
      // trigger real form submit
      form.requestSubmit();
    });
  }

  const observer = new IntersectionObserver(
    ([entry]) => {
      sticky.classList.toggle('active', !entry.isIntersecting);
    },
    { threshold: 0 }
  );

  observer.observe(btn);
  }

  /* -------------------------
     INIT ALL
  -------------------------- */
  const galleryAPI = initGallery();
  initZoom();
  initVariants(galleryAPI);
  initQuantity();
  initSticky();
}

const initializedSections = new Set();
function safeInit(section) {
  if (!section || !section.id) return;
  if (initializedSections.has(section.id)) return;
  initializedSections.add(section.id);
  initProductScript(section.id);
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[id^='MainProduct_']").forEach(safeInit);
});

document.addEventListener("shopify:section:load", (e) => {
  safeInit(e.target);
});

const observer = new MutationObserver((mutations) => {
  mutations.forEach(mutation => {
    mutation.addedNodes.forEach(node => {
      if (node.nodeType !== 1) return;
      if (node.matches?.("[id^='MainProduct_']")) {
        safeInit(node);
      }
      node.querySelectorAll?.("[id^='MainProduct_']").forEach(safeInit);
    });
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["block_shipping_bar"] && !Shopify.designMode) return;
  try {
    (function () {
    let cartCache = null;
    function getCart() {
      return fetch('/cart.js')
        .then((res) => res.json())
        .then((cart) => {
          cartCache = cart;
          return cart;
        });
    }
    function updateFreeShippingBar() {
      getCart().then((cart) => {
        const wrappers = document.querySelectorAll('.cart-progress-wrapper');
        if (!wrappers.length) return;
        // ✅ Calculate NON-subscription total
        let nonSubscriptionTotal = 0;
        cart.items.forEach((item) => {
          // if (!item.selling_plan_allocation) {
          //   nonSubscriptionTotal += item.line_price;
          // }
          nonSubscriptionTotal += item.line_price;
        });

        const rate = Shopify?.currency?.rate || 1;
        const currency = Shopify?.currency?.active || 'USD';

        wrappers.forEach((wrapper) => {
          const bar = wrapper.querySelector('.cart-progress-bar');
          const message = wrapper.querySelector('.goal-message');

          const thresholdUSD = parseInt(wrapper.dataset.threshold || 0);
          if (!thresholdUSD) return;

          const threshold = thresholdUSD * rate;
          const cartTotal = nonSubscriptionTotal;
      
          let progress = (cartTotal / threshold) * 100;
          progress = Math.min(progress, 100);

          let remaining = Math.max(threshold - cartTotal, 0);

          const formatted = new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: currency,
          }).format(remaining / 100);

          // ✅ UI update
          if (bar) bar.style.width = progress + '%';

          if (wrapper) {
            if (progress >= 100) {
              wrapper.classList.add('is-complete');
            } else {
              wrapper.classList.remove('is-complete');
            }
          }

          const template = wrapper.dataset.preGoalMessageTemplate;
          const success = wrapper.dataset.postGoalMessage;

          if (message) {
            if (remaining > 0) {
              message.innerHTML = template.replace('[amount]', formatted);
            } else {
              message.innerHTML = success;
            }
          }
        });
      });
    }

    // ✅ INIT
    document.addEventListener('DOMContentLoaded', updateFreeShippingBar);

    // ✅ Shopify cart events (if supported)
    document.addEventListener('cart:updated', updateFreeShippingBar);
    document.addEventListener('ajaxCart:updated', updateFreeShippingBar);

    // ✅ Fallback (works in ALL themes)
    document.addEventListener('click', function () {
      setTimeout(updateFreeShippingBar, 300);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["block_slider"] && !Shopify.designMode) return;
  try {
    function initSlider(id) {
    const slider = document.getElementById('slider-' + id);

    if (!slider) return;

    const track = document.getElementById('track-' + id);

    const prev = slider.querySelector('.slider-prev');

    const next = slider.querySelector('.slider-next');

    const dotsWrap = document.getElementById('dots-' + id);

    const slides = [...track.children];

    const infinite = slider.dataset.infinite === 'true';

    const adaptive = slider.dataset.adaptive === 'true';

    const autoplay = slider.dataset.autoplay === 'true';

    const speed = parseInt(slider.dataset.speed) || 3000;

    let index = 0;

    /* -------------------- */

    function getPerRow() {
      const desktop = parseInt(slider.dataset.perDesktop) || 1;

      const tablet = parseInt(slider.dataset.perTablet) || 1;

      const mobile = parseInt(slider.dataset.perMobile) || 1;

      if (window.innerWidth >= 1366) return desktop;

      if (window.innerWidth >= 768) return tablet;

      return mobile;
    }

    /* -------------------- */

    function updateHeight() {
      if (!adaptive) return;

      const inner = slider.querySelector('.slider-inner');

      const slide = slides[index];

      if (!slide) return;

      inner.style.height = slide.offsetHeight + 20 + 'px';
    }

    /* -------------------- */

    function go(i) {
      const perRow = getPerRow();

      const pages = Math.ceil(slides.length / perRow);

      const maxIndex = (pages - 1) * perRow;

      if (infinite) {
        if (i > maxIndex) i = 0;

        if (i < 0) i = maxIndex;
      } else {
        if (i > maxIndex) i = maxIndex;

        if (i < 0) i = 0;
      }

      index = i;

      const slide = slides[index];

      if (!slide) return;

      track.scrollTo({
        left: slide.offsetLeft,
        behavior: 'smooth',
      });

      updateDots();
      updateHeight();
    }

    /* -------------------- */
    /* swipe / scroll dots fix */

    let scrollTimer;

    track.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);

      scrollTimer = setTimeout(() => {
        const perRow = getPerRow();

        let closest = 0;
        let min = Infinity;

        slides.forEach((slide, i) => {
          const diff = Math.abs(slide.offsetLeft - track.scrollLeft);

          if (diff < min) {
            min = diff;
            closest = i;
          }
        });

        index = Math.floor(closest / perRow) * perRow;

        updateDots();
        updateHeight();
      }, 80);
    });

    /* -------------------- */

    if (prev) prev.onclick = () => go(index - getPerRow());

    if (next) next.onclick = () => go(index + getPerRow());

    /* -------------------- */

    function buildDots() {
      if (!dotsWrap) return;

      dotsWrap.innerHTML = '';

      const perRow = getPerRow();

      const pages = Math.ceil(slides.length / perRow);

      for (let i = 0; i < pages; i++) {
        const b = document.createElement('button');

        b.onclick = () => go(i * perRow);

        dotsWrap.appendChild(b);
      }
    }

    /* -------------------- */

    function updateDots() {
      if (!dotsWrap) return;

      const perRow = getPerRow();

      const page = Math.round(index / perRow);

      dotsWrap.querySelectorAll('button').forEach((d, i) => {
        d.classList.toggle('active', i === page);
      });
    }

    /* -------------------- */

    let autoTimer = null;

      /* -------------------- */
      /* AUTOPLAY */

      function startAutoplay() {
        if (!autoplay) return;

        stopAutoplay(); // prevent stacking

        autoTimer = setInterval(() => {
          go(index + getPerRow());
        }, speed);
      }

      function stopAutoplay() {
        if (autoTimer) {
          clearInterval(autoTimer);
          autoTimer = null;
        }
      }

      /* -------------------- */
      /* HOVER FIX (IMPORTANT) */

      slider.addEventListener('mouseenter', () => {
        stopAutoplay();
      });

      slider.addEventListener('mouseleave', () => {
        startAutoplay();
      });

      /* -------------------- */
      /* DRAG FIX */

      let isDown = false;
      let startX;
      let scrollLeft;

      track.addEventListener('pointerdown', (e) => {
        isDown = true;
        startX = e.pageX;
        scrollLeft = track.scrollLeft;

        stopAutoplay(); // pause while dragging
      });

      track.addEventListener('pointerup', () => {
        isDown = false;
        startAutoplay(); // resume
      });

      track.addEventListener('pointerleave', () => {
        isDown = false;
        startAutoplay(); // resume
      });

      track.addEventListener('pointermove', (e) => {
        if (!isDown) return;

        const walk = e.pageX - startX;
        track.scrollLeft = scrollLeft - walk;
      });
    buildDots();
    updateDots();
    updateHeight();
    startAutoplay();

    window.addEventListener('resize', () => {
      buildDots();
      updateDots();
      updateHeight();
      startAutoplay();
    });
  }

  /* ---------- INIT ---------- */

  document.querySelectorAll('.slider_block').forEach((el) => {
    initSlider(el.dataset.id);
  });

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.slider_block').forEach((el) => {
      initSlider(el.dataset.id);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["block_tabs"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.tab-btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      const tabId = btn.dataset.tab;
      const wrapper = btn.closest('.tabs_collection');
      // remove active
      wrapper.querySelectorAll('.tab-btn').forEach((b) => b.classList.remove('active'));
      wrapper.querySelectorAll('.tab-content').forEach((c) => c.classList.remove('active'));
      // add active
      btn.classList.add('active');
      wrapper.querySelector('#' + tabId).classList.add('active');
    });
  });
  document.querySelectorAll('.tab-content').forEach((item) => {
    const productCart = item.querySelectorAll('.product-card');
    productCart.forEach((button) => {
      button.addEventListener('click', () => {
         button.classList.toggle('is-selected');
        const section = button.querySelector(['[data-section]']);
        const paretDiv = button.closest('.tab-content');
        const bundle = paretDiv.querySelectorAll('[data-bundle]')[0];
        //console.log(bundle);
        if (!bundle) return;
        // get all selected products inside this bundle
        const selectedProducts = paretDiv.querySelectorAll('.is-selected');
        //console.log(selectedProducts);
        let totalPrice = 0;
        selectedProducts.forEach((el) => {
          const price = parseInt(el.dataset.price || 0);
          totalPrice += price;
        });
        const dataEl = bundle.querySelector('.bundle-data');
        
          const items = [];
          selectedProducts.forEach((el) => {
            const id = parseInt(el.dataset.variantId);
            const available = el.dataset.available !== 'false'; // optional
            if (id) {
              items.push({
                id: id,
                available: available
              });
            }
          });
          // 🔥 THIS is the correct way
          dataEl.dataset.items = JSON.stringify(items);
        const shopCurrency = section.dataset.currency;
        const shopLocale = section.dataset.locale;
        const formatMoney = (cents) => {
          const rate = Shopify?.currency?.rate || 1;
          const converted = cents / 100;
          return new Intl.NumberFormat(Shopify.locale, {
            style: 'currency',
            currency: Shopify.currency.active,
          }).format(converted);
        };
        const discount = parseFloat(bundle.dataset.discount || 0);
        //console.log(discount);
        const discountAmount = Math.round((totalPrice * discount) / 100);
        const finalPrice = Math.round(totalPrice - discountAmount);
        //console.log(finalPrice);
        // update UI (ONLY these 3 things)
        const bundlePrice = bundle.querySelector('.bundle_price');
        //console.log(bundlePrice);
        if (bundlePrice) {
          bundlePrice.textContent = formatMoney(Math.round(totalPrice));
        }
        const saveBundle = bundle.querySelector('.saveBundle');
        
        //console.log(saveBundle);
        if (saveBundle) {
          if(selectedProducts.length >= 2){
          saveBundle.textContent = formatMoney(finalPrice);
          }else{
          saveBundle.textContent = formatMoney(totalPrice);
          }
        }
        const saveEl = bundle.querySelector('.youSave');
        if (saveEl) {
          saveEl.textContent = `You save ${formatMoney(discountAmount)} (${discount}% OFF)`;
        }
        const AddButton = bundle.querySelector('.bundle-add-btn');
        if(selectedProducts.length >= 2){
          AddButton.classList.remove('disabled')
        }else{
          AddButton.classList.add('disabled')
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["block_timer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    function initTimers() {
      document.querySelectorAll('.offer-timer').forEach((timer) => {
        if (timer.dataset.init) return;
        timer.dataset.init = 'true';
        const start = new Date(timer.dataset.start).getTime();
        const end = new Date(timer.dataset.end).getTime();
        const daysEl = timer.querySelector('.days');
        const hoursEl = timer.querySelector('.hours');
        const minutesEl = timer.querySelector('.minutes');
        const secondsEl = timer.querySelector('.seconds');
        function updateTimer() {
          const now = new Date().getTime();
          if (now < start) {
            timer.style.display = 'none';
            return;
          }
          if (now > end) {
            timer.style.display = 'none';
            return;
          }
          timer.style.display = 'block';
          const distance = end - now;
          const days = Math.floor(distance / (1000 * 60 * 60 * 24));
          const hours = Math.floor((distance / (1000 * 60 * 60)) % 24);
          const minutes = Math.floor((distance / (1000 * 60)) % 60);
          const seconds = Math.floor((distance / 1000) % 60);
          daysEl.textContent = String(days).padStart(2, '0');
          hoursEl.textContent = String(hours).padStart(2, '0');
          minutesEl.textContent = String(minutes).padStart(2, '0');
          secondsEl.textContent = String(seconds).padStart(2, '0');
        }
        updateTimer();
        setInterval(updateTimer, 1000);
      });
    }
    initTimers();
    const observer = new MutationObserver(() => {
      initTimers();
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
  } catch(e) { console.error(e); }
})();

})();
